module.exports = __webpack_public_path__ + "img/hohlschnitt_weiss_candy.17cb768a.jpg";